import { BaseDto } from "@/shared/dtos/base-dto";

export class mediciones_inventario extends BaseDto {
  public comprobacion!: string;
  public lectura!: string;
  public estado!: string;
  public id_inventario!: number;
}
